// Quantities with different units must never be added together.
export function materialNeedTotals(lines, quantity = line => line.needed) {
  const totals = new Map();
  for (const line of lines) {
    const unit = line.unit || 'ud';
    totals.set(unit, (totals.get(unit) || 0) + Number(quantity(line) || 0));
  }
  return [...totals].map(([unit, total]) => `${total.toLocaleString('es-ES', { maximumFractionDigits: 4 })} ${unit}`).join(' · ');
}

export const needMoney = value => Number(value || 0).toLocaleString('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const needAmount = line => Number(line.needed ?? line.totalQuantity ?? 0) * Number(line.unit_cost || 0);
export function materialNeedSummary(lines, quantity = line => line.needed, amount = needAmount) {
  return `${materialNeedTotals(lines, quantity)} · ${needMoney(lines.reduce((sum, line) => sum + amount(line), 0))}`;
}
